<div class="app-form">
    <!-- Form Title - Always visible -->
    <h2 class="form-title" *ngIf="formTitle">{{ formTitle }}</h2>

    <!-- Deadline Info -->
    <div class="deadline-info" *ngIf="formDeadline">
        <p class="deadline-text" [class.deadline-passed]="isDeadlinePassed">
            <ion-icon name="time-outline"></ion-icon>
            <span *ngIf="!isDeadlinePassed">
                {{ "form.deadline" | translate }}:
                {{ formDeadline | date: "short" }}
            </span>
            <span *ngIf="isDeadlinePassed">
                {{ "form.deadline-passed" | translate }}
            </span>
        </p>
    </div>

    <!-- Form Content -->
    <div *ngIf="!hasSubmitted">
        <div class="form-section" *ngFor="let field of formFields">
            <!-- Checkbox Field -->
            <ion-item class="checkbox-item" *ngIf="field.type === 'checkbox'">
                <ion-checkbox
                    slot="start"
                    [checked]="formData[field.name]"
                    (ionChange)="onFieldChange(field.name, $event)"
                ></ion-checkbox>
                <ion-label class="label">
                    {{ field.label }}
                </ion-label>
            </ion-item>

            <!-- Select Field as Radio Group -->
            <div *ngIf="field.type === 'select'">
                <h3 class="form-question">{{ field.label }}</h3>
                <div class="selection-container">
                    <ion-radio-group
                        [value]="formData[field.name]"
                        (ionChange)="onFieldChange(field.name, $event)"
                    >
                        <ion-item
                            *ngFor="let option of field.options"
                            class="option"
                            [class.option-selected]="
                                formData[field.name] === option.name
                            "
                        >
                            <ion-radio
                                slot="start"
                                [value]="option.name"
                            ></ion-radio>
                            <ion-label class="label">
                                {{ option.label || option.name }}
                            </ion-label>
                        </ion-item>
                    </ion-radio-group>
                </div>
            </div>
        </div>

        <div class="form-actions">
            <ion-button
                expand="block"
                [disabled]="!isFormValid() || isSubmitting"
                (click)="submitForm()"
                class="submit-button"
            >
                <ion-spinner
                    *ngIf="isSubmitting"
                    name="crescent"
                    class="spinner"
                ></ion-spinner>
                <span *ngIf="!isSubmitting">
                    {{ "form.submit" | translate }}
                </span>
            </ion-button>
        </div>
    </div>

    <!-- Success Message -->
    <div class="submission-success" *ngIf="hasSubmitted">
        <p>
            {{
                successMessage ||
                    ("form.submission-success-message" | translate)
            }}
        </p>
    </div>
</div>
